export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/** Tile edge per size, in rem against the console's 12px root (24, 32, 38,
 *  46 and 56 design px). The top-bar launcher reads `sm` too, so it stands
 *  exactly as tall as the agent tile in the panel header beside it. */
export const AVATAR_SIZE_REM: Record<AvatarSize, number> = {
  xs: 2,
  sm: 2.6667,
  md: 3.1667,
  lg: 3.8333,
  xl: 4.6667,
};
